export const cyclecentralData = {
  config: {
    id: 'cyclecentral',
    name: 'Cycle Central',
    subtitle: 'Urban Mobility Rentals',
    supportEmail: 'hello@cyclecentral.co',
    customMessage: 'For long-term rentals, please contact us for custom pricing',
    currency_code: 'EUR',
    currency_symbol: '€',
    timezone: 'Europe/Berlin',
    country_code: 'DE',
    default_language: 'de',
    supported_languages: ['de', 'en', 'fr', 'it', 'hu', 'fi'],
    debug: false,
  },
  popularDurations: ['1d'],
  locations: [
    {
      id: 'grand-station',
      slug: 'grand-station',
      name: 'Grand Station Depot',
      address: '789 Transport Avenue, Metro City',
      hours: '5:00 AM - 11:00 PM',
      rating: 4.9,
      bikes: 40,
      image: 'https://images.unsplash.com/photo-1505706904149-38e4a18c644e?w=400&h=250&fit=crop',
    },
    {
      id: 'parkside-kiosk',
      slug: 'parkside-kiosk',
      name: 'Parkside Kiosk',
      address: '101 Park Drive, Green Valley',
      hours: '8:00 AM - 8:00 PM',
      rating: 4.7,
      bikes: 15,
      image: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=400&h=250&fit=crop',
    },
  ],
  bikes: [
    {
      id: 'urban-glider',
      name: 'Urban Glider V2',
      category: 'City Bikes',
      price: 30,
      image: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=400&h=300&fit=crop',
      sizes: [
        { size: 'M', height: '160-180cm' },
        { size: 'L', height: '175-190cm' },
      ],
      features: ['Lightweight Frame', '8-Speed Internal Hub', 'Puncture-Proof Tires', 'Front & Rear Lights'],
      description: 'The ultimate city bike for smooth and efficient urban travel.',
      availableAddons: ['basic_insurance', 'phone_mount'],
    },
    {
      id: 'scoot-pro',
      name: 'Scoot Pro',
      category: 'E-Scooters',
      price: 40,
      image: 'https://images.unsplash.com/photo-1599231313835-2ea52b3b4a28?w=400&h=300&fit=crop',
      sizes: [{ size: 'One Size', height: '150-195cm' }],
      features: ['40km Range', 'Dual Braking System', 'Foldable Design', 'Bright LED Display'],
      description: 'Zip through the city on our powerful and convenient e-scooter.',
      popular: true,
      availableAddons: ['basic_insurance', 'premium_helmet'],
    },
    {
      id: 'cargo-cruiser',
      name: 'Cargo Cruiser',
      category: 'Specialty',
      price: 80,
      image: 'https://images.unsplash.com/photo-1620892305333-30f536a43936?w=400&h=300&fit=crop',
      sizes: [{ size: 'One Size', height: '165-190cm' }],
      features: ['Large Front Cargo Box', 'Electric Assist', 'Stable Three-Wheel Design', 'Child Seat Compatible'],
      description: 'Perfect for hauling groceries, packages, or taking the kids for a ride.',
      availableAddons: ['basic_insurance', 'child_seat_addon'],
    },
  ],
  addons: {
    basic_insurance: {
      id: 'basic_insurance',
      name: 'Basic Insurance',
      description: 'Covers minor damages up to $100. Does not cover theft.',
      price: 10.0,
      priceType: 'fixed',
    },
    phone_mount: {
      id: 'phone_mount',
      name: 'Universal Phone Mount',
      description: 'A sturdy phone mount for easy navigation.',
      price: 4.0,
      priceType: 'fixed',
    },
    premium_helmet: {
      id: 'premium_helmet',
      name: 'Premium Helmet',
      description: 'Upgrade to a lightweight helmet for extra comfort and safety.',
      price: 8.0,
      priceType: 'fixed',
    },
    child_seat_addon: {
      id: 'child_seat_addon',
      name: 'Cargo Bike Child Seat',
      description: 'A secure child seat for our Cargo Cruiser model.',
      price: 15.0,
      priceType: 'fixed',
    },
  },
};